import { Grid, Box } from "@material-ui/core";
import { Card, StatusChip, StatusType } from "@roc/ui";
import { observer } from "mobx-react";
import { activityTypeOptionsMapping } from "../leads/constants/constants";
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@roc/ui';
import { Add } from '@material-ui/icons';
import { HtmlContainer } from '../leadDetails/htmlContainer';
import { EditLeadActivityDialog } from "./editLeadActivityDialog";
import { Note } from "./note";
import { formatDate } from "@roc/feature-utils";

const useStyles = makeStyles(theme => ({
  button: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),
    minWidth: '150px',
  },
  notesScroll: {
    backgroundColor: '#FAFAFA',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    maxHeight: '800px',
    overflowY: 'auto',
    overflowX: 'hidden',
    boxShadow: '0 0 2px #DDD inset'
  },
}));

export const ContactActivitiesCard = observer(({ leadDetailsStore }) => {
  const classes = useStyles();
  const { editLeadActivityStore } = leadDetailsStore;

  const action = (
    <Box p={1} mb={-10}>
      <Button
        testId="add-lead-activity"
        className={classes.button}
        variant="contained"
        size="small"
        color="primary"
        onClick={() => editLeadActivityStore.openAddLeadActivity()}
      >
        <Add /> Add Activity
      </Button>
    </Box>
  );

  const getActivityType = leadActivity => {
    return activityTypeOptionsMapping.find(
      opt => opt.value === leadActivity.activityType
    )?.label;
  };

   const getActivityTitle = leadActivity => {
    const activityType = getActivityType(leadActivity);
    const iscallActivity = activityType && activityType.toLowerCase().includes("call");
    const activityDate = leadActivity.sentDate ? leadActivity.sentDate : leadActivity.createdDate;
     return (
       <Grid container justifyContent="space-between">
         <Grid item xs={6}>
           {activityDate ? formatDate(activityDate,'MM/dd/yyyy') : ''} - {getActivityType(leadActivity)}
         </Grid>
         <Grid item xs={6}>
           {iscallActivity && (
             <Box textAlign="right">
               <Box mr={1} component="span">
                 <StatusChip
                   statusType={StatusType.CALL_STATUS}
                   label={leadActivity.result}
                   size="small"
                   variant="filled"
                 />
               </Box>
               <Box mr={1} component="span">
                 <StatusChip
                   statusType={StatusType.CALL_STATUS}
                   label={getCallDurationLabel(leadActivity.callDuration)}
                   size="small"
                   variant="filled"
                 />
               </Box>
             </Box>
           )}
         </Grid>
       </Grid>
     );
   };

   const getCallDurationLabel = callDuration => {
    if(callDuration && callDuration <= 60) {
      return `${callDuration} secs`;
    } else if (callDuration && callDuration > 60) {
      const minutes = Math.floor(callDuration/60);
      const seconds = callDuration % 60;
      return `${minutes} mins and ${seconds} secs`;
    }
   }

  return (
    <Card
      title="Activities"
      cardHeaderProps={{ action }}
      cardContentProps={{ className: classes.notesScroll }}
    >
      {leadDetailsStore.leadActivities.length > 0 ? (
        <Grid container spacing={2}>
          {leadDetailsStore.leadActivities.map(leadActivity => (
            <Grid item xs={12}>
              <Note
                title={getActivityTitle(leadActivity)}
                onEdit={() =>
                  editLeadActivityStore.openEditLeadActivity(leadActivity)
                }
                createdDate={leadActivity.createdDate}
                lastUpdatedDate={leadActivity.lastUpdatedDate}
                createdBy={leadActivity.createdByName}
                lastModifiedBy={leadActivity.lastUpdatedByName}
              >
                <HtmlContainer
                  html={
                    leadActivity.emailContent
                      ? leadActivity.emailContent.substring(0, 300) + '...'
                      : leadActivity.text
                  }
                />
              </Note>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Box textAlign="center">No records.</Box>
      )}
      <EditLeadActivityDialog editLeadActivityStore={editLeadActivityStore} />
    </Card>
  );
});
